// ButtonLoading — toggles data-loading on the element during phx events.
// Phoenix LiveView emits phx:loading:start/stop automatically for phx-click
// and phx-submit targets. We use these to surface an instant visual state
// without depending on phx-disable-with.
export default {
  mounted() {
    this.onStart = () => {
      this.el.setAttribute("data-loading", "true")
      this.el.setAttribute("aria-busy", "true")
    }
    this.onStop = () => {
      this.el.removeAttribute("data-loading")
      this.el.removeAttribute("aria-busy")
    }
    this.el.addEventListener("phx:loading:start", this.onStart)
    this.el.addEventListener("phx:loading:stop", this.onStop)
  },
  destroyed() {
    this.el.removeEventListener("phx:loading:start", this.onStart)
    this.el.removeEventListener("phx:loading:stop", this.onStop)
  },
}
